import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InvoiceBatchDTO } from '../../services/apiClient';
import { useInvoiceBatchApi } from '../../hooks/useInvoiceBatchApi';
import InvoiceBatchTable from '../tables/InvoiceBatchTable';

interface ViewMemberBatchesProps {
  memberId: string;
  idPassportNumber: string;
}

const ViewMemberBatches: React.FC<ViewMemberBatchesProps> = ({ memberId, idPassportNumber }) => {
  const { getMemberBatches, isLoading } = useInvoiceBatchApi();
  const [allItems, setAllItems] = useState<InvoiceBatchDTO[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    if (!memberId) {
      setAllItems([]);
      return;
    }

    (async () => {
      try {
        const response = await getMemberBatches(memberId);
        setAllItems(response?.data || []);
        setCurrentPage(1);
      } catch (error) {
        console.error('Error fetching member invoice batches:', error);
        setAllItems([]);
      }
    })();
  }, [memberId]);

  const pagedItems = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return allItems.slice(start, start + pageSize);
  }, [allItems, currentPage, pageSize]);

  const totalPages = Math.max(1, Math.ceil(allItems.length / pageSize));

  const handleViewBatchDetail = (batch: InvoiceBatchDTO) => {
    if (!batch.id) return;
    const suffix = idPassportNumber ? `?idPassportNumber=${encodeURIComponent(idPassportNumber)}` : '';
    navigate(`/admin/invoicebatches/${batch.id}${suffix}`);
  };

  return (
    <InvoiceBatchTable
      data={pagedItems}
      handleViewBatchDetail={handleViewBatchDetail}
      currentPage={currentPage}
      totalPages={totalPages}
      setCurrentPage={setCurrentPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ViewMemberBatches;
